import { appContext } from '../../../../web/models/getHelp/appContext';
import { ExperienceMetaData } from '../../../../web/models/getHelp/experienceConfigurations';
import {
  createSelector,
  IContactUsState,
  IModalitySectionState,
  ISelfHelpAlchemyState,
  ISharedState,
} from '../../../models/reduxState';
import {
  contactStateSelector,
  getHelpConfigSelector,
  isGetHelpSelector,
  modalitySectionStateSelector,
  sharedStateSelector,
} from './contactUsSelector';

export const selfHelpAlchemyStateSelector = createSelector(
  contactStateSelector,
  (c: IContactUsState) => c.SelfHelpAlchemyState
);

export const isMultiInsightsEnabledSelector = createSelector(
  [selfHelpAlchemyStateSelector],
  (alchemyState: ISelfHelpAlchemyState) => alchemyState.isMultiInsightsEnabled
);

export const isTopResultForSelfHelpEnabledSelector = createSelector(
  [selfHelpAlchemyStateSelector],
  (s: ISelfHelpAlchemyState) => s.isTopResultForSelfHelpEnabled
);

export const deeplinkPathSelector = createSelector(sharedStateSelector, (s: ISharedState) => s.deeplinkPath);

export const isGetHelpBtnHiddenSelector = createSelector(
  selfHelpAlchemyStateSelector,
  (s: ISelfHelpAlchemyState) => s.hideGetHelpBtn
);

export const isPrivacyAndSupportHiddenSelector = createSelector(
  selfHelpAlchemyStateSelector,
  (s: ISelfHelpAlchemyState) => s.hidePrivacyAndSupport
);

export const isDeeplinkAndGetHelpSelector = createSelector(
  [deeplinkPathSelector, isGetHelpSelector],
  (deeplinkPath: string, isGetHelp: boolean) => {
    return !!deeplinkPath && isGetHelp;
  }
);

export const shouldProceedQueryForGetHelpSelector = createSelector(
  [getHelpConfigSelector, modalitySectionStateSelector, isDeeplinkAndGetHelpSelector],
  (
    getHelpConfig: ExperienceMetaData,
    modalityState: IModalitySectionState,
    isDeeplinkAndGetHelp: boolean
  ) => {
    const configReadyOrNotSupport = appContext.appSupportsConfigUpdate ? !!getHelpConfig : true;
    const userInfoReadyOrNotSignedInOrNotSupport =
      appContext.appSupportsAuth && !appContext.isCommercial
        ? modalityState.userInfoFetchEnded || modalityState.errorOnSignIn
        : true;
    return isDeeplinkAndGetHelp && configReadyOrNotSupport && userInfoReadyOrNotSignedInOrNotSupport;
  }
);

export const showBCQRV2Selector = createSelector(
  selfHelpAlchemyStateSelector,
  (s: ISelfHelpAlchemyState) => s.showBCQRV2
);

